import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Space,
  Form,
  Input,
  DatePicker,
  Select,
  Col,
  Row,
} from "antd";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { fetchMembers } from "../../../../api/member";

const { RangePicker } = DatePicker;
const { Option } = Select;

const SearchForm = ({
  data,
  setData,
  pagination,
  setPagination,
  handleDelete,
  handleEdit,
  changeStatus,
  parseRoleId,
  parseStatus,
  handleSearch,
  fetchData,
  searchParam,
  setSearchParam,
  handleSearchForPageOne,
  showAddMemberBtn,
}) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const columns = [
    {
      title: "账户手机号",
      dataIndex: "phone_no",
      key: '"phone_no"',
      align: "center",
    },
    {
      title: "成员昵称",
      dataIndex: "nick_name",
      key: "nick_name",
      align: "center",
    },
    {
      title: "学员学号",
      dataIndex: "user_no",
      key: "user_no",
      align: "center",
    },
    {
      title: "权限",
      dataIndex: "role_id",
      key: "role_id",
      align: "center",
      render: (roleId) => {
        return parseRoleId(roleId);
      },
    },
    {
      title: "创建时间",
      dataIndex: "ctime",
      key: "ctime",
      align: "center",
    },
    {
      title: "修改时间",
      dataIndex: "mtime",
      key: "mtime",
      align: "center",
    },
    {
      title: "状态",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (status) => {
        return parseStatus(status);
      },
    },
    {
      title: "操作",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="small">
          <Button type="link" onClick={() => handleEdit(record)}>
            编辑
          </Button>
          <Button type="link" onClick={() => handleDelete(record)}>
            删除
          </Button>
          <Button type="link" onClick={() => changeStatus(record, 0)}>
            停用
          </Button>
          <Button type="link" onClick={() => changeStatus(record, 1)}>
            启用
          </Button>
        </Space>
      ),
    },
  ];

  const handleReset = () => {
    form.resetFields();
    setSearchParam({});
    setPagination({ page_no: 1, page_size: 10, count: 0 });
    fetchData();
  };

  const handleCreateMember = () => {
    navigate("/UserAdd");
  };

  const handleLast7Days = () => {
    const end = moment().endOf("day");
    const start = moment().subtract(7, "days").startOf("day");
    handleSearch({ ...form.getFieldsValue(), mtime: [start, end] });
  };

  const handleLast30Days = () => {
    const end = moment().endOf("day");
    const start = moment().subtract(30, "days").startOf("day");
    handleSearch({ ...form.getFieldsValue(), mtime: [start, end] });
  };

  return (
    <div style={{ padding: "20px" }}>
      {showAddMemberBtn ? (
        <div style={{ marginBottom: "20px" }}>
          <Button type="primary" onClick={handleCreateMember}>
            新增成员
          </Button>
        </div>
      ) : null}

      <Form form={form} layout="inline" onFinish={handleSearchForPageOne}>
        <Row align="left" style={{ marginTop: "10px", marginBottom: "5px" }}>
          <Col>
            <Form.Item name="role_id" label="管理权限">
              <Select placeholder="请选择" style={{ width: "140px" }}>
                <Option value={"1"}>高级管理员</Option>
                <Option value={"2"}>智慧豆录入员</Option>
                <Option value={"3"}>智慧豆审核员</Option>
                <Option value={"4"}>智慧豆录入和审核员</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="status" label="状态">
              <Select placeholder="请选择" style={{ width: "140px" }}>
                <Option value={1}>已启用</Option>
                <Option value={0}>未启用</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row align="left" style={{ marginTop: "10px", marginBottom: "10px" }}>
          <Col>
            <Form.Item name="phone_no" label="账户手机号">
              <Input placeholder="请输入手机号" style={{ width: "140px" }} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="nick_name" label="成员昵称">
              <Input placeholder="请输入昵称" style={{ width: "140px" }} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="user_no" label="必经之路学号">
              <Input placeholder="请输入学号" style={{ width: "140px" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ marginTop: "10px", marginBottom: "5px" }}>
          <Col>
            <Form.Item name="mtime" label="修改时间">
              <RangePicker
                showTime={{ format: "HH:mm:ss" }}
                format="YYYY-MM-DD HH:mm:ss"
                style={{ width: "360px" }}
              />
            </Form.Item>
          </Col>
          <Button type="link" onClick={handleLast7Days}>
            最近七天
          </Button>
          <Button
            type="link"
            style={{ marginLeft: 8 }}
            onClick={handleLast30Days}
          >
            最近三十天
          </Button>
        </Row>
      </Form>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <Button type="primary" onClick={form.submit}>
          筛选
        </Button>
        <Button
          type="text"
          style={{ color: "#0F64FF", marginLeft: 8 }}
          onClick={handleReset}
        >
          重置
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={data}
        pagination={{
          current: pagination.page_no,
          pageSize: pagination.page_size,
          total: pagination.total,
          onChange: (page_no, page_size) => {
            setSearchParam(form.getFieldsValue());
            setPagination({
              ...pagination,
              page_no: page_no,
              page_size: page_size,
            });
          },
        }}
        rowKey="user_no"
        style={{ textAlign: "center", marginTop: "20px" }}
      />
    </div>
  );
};

export default SearchForm;
